import { useSettingsResource } from './useSettingsResource.js'

/**
 * The shape `/v1/marketing/settings` reads and writes.
 *
 * Separate from the checkout settings on purpose. The countdown and the
 * "frequently bought together" list are rendered by the same storefront embed
 * as the Buy Now button, but they are not part of it: a store can run a
 * campaign with the button switched off, and a store can run the button with no
 * campaign at all.
 */
export interface MarketingSettings {
  countdownEnabled: boolean
  countdownTitle: string
  countdownSubtitle: string
  countdownType: 'duration' | 'date' | 'daily'
  /** Seconds. */
  countdownDuration: number
  countdownEndsAt: string
  countdownDailyStart: string
  countdownDailyEnd: string
  /** ISO weekdays, comma separated. 1 = Monday. */
  countdownDailyDays: string
  countdownBg: string
  countdownText: string
  countdownCtaLabel: string
  countdownCtaUrl: string
  countdownOnEnd: 'message' | 'hide' | 'repeat' | 'nothing'
  countdownEndedText: string
  countdownControlsOffer: boolean
  countdownExpiredAction: 'hide' | 'no_discount' | 'message'
  /** Which storefront pages the banner runs on. */
  countdownDisplayOn: 'product' | 'all'

  fbtEnabled: boolean
  fbtHeading: string
  fbtDisplayOn: 'checkout' | 'product' | 'both'
  fbtHelpEnabled: boolean
}

export function useMarketingSettings() {
  return useSettingsResource<MarketingSettings>('/v1/marketing/settings', 'marketing-settings')
}
